import React from 'react'
import ReactDOM from 'react-dom/client'
import './theme/tokens.css'
import './theme/bootstrap-overrides.scss'
import App from './App'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<App />)
